<template>
<div class="form-submission-card">
    <submission-title
        :form_name="form_submission.instance.form.name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        :pdf_mode="pdf_mode"
        @open-signature="openSignature(false)"
    />

    <div class="form-submission-card-content">
        <list-of-operatives-signatures
            class="form-submission-card-content-child"
            :data="form_submission.initial_briefings"
            :show_url="show_url"
            :inline_signature="pdf_mode"
            is_nested
        />
    </div>
</div>
</template>

<script>
import ListOfOperativesSignatures from '../forms/ListOfOperativesSignatures';
import SubmissionTitle from './SubmissionTitle';
import SubmissionSubtitle from './SubmissionSubtitle';

export default {
    name: 'InitialBriefingSubmission',
    components: {
        ListOfOperativesSignatures,
        SubmissionTitle,
        SubmissionSubtitle,
    },
    props: {
        form_submission: Object,
        show_url: String,
        pdf_mode: Boolean,
    },
};
</script>
